import React from 'react';
import { Dispatch } from 'redux';
import { connect } from "react-redux";
import { IApplicationState, RootActionCreators } from '../../../store';
import { createStyles, makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { INaviagtions, mapNavigationsToProps, OutreachNavigation, OutreachNavigationPage } from '../../organisms/outreach/OutreachNavigation';
import { IData as IOutreachItem, defaultOutreachItem as EmptyOutreachItem } from "../../../store/outreach/OutreachItem";
import { PageHeader } from '../../organisms/PageHeader';
import { OutreachForm } from '../../organisms/outreach/OutreachForm';


import { FetchState } from '../../../entities/FetchState';
import { IReportDataObject, IReportData } from '../../../entities/reports/IReportData';
import { IMedewerkerList } from '../../../store/selectie';
import { IData as IOutreachDoelgroep } from "../../../store/outreach/OutreachDoelgroepen";
import { IData as IOutreachSetting } from "../../../store/outreach/outreachSettings";
import ErrorMessage from '../../organisms/ErrorMessage';
import { SavingMessage } from '../../organisms/SavingMessage';
import { SaveButton } from '../../atoms/buttons/SaveButton';


// CSS
const useStyles = makeStyles((theme: Theme) =>
    createStyles({}),
  ); 


// Standard Properties from parent component
interface IProps { }

// Outgoing functions to parent component
interface IDispatch {}

// Properties from State 
interface IStateProps {
    doelgroepen: IReportData<IOutreachDoelgroep>
    settings: IReportDataObject<IOutreachSetting>
    medewerkers: IMedewerkerList
    addNewState: IReportDataObject<IOutreachItem>
 }
const mapStateProps = (state: IApplicationState): IStateProps => ({
    doelgroepen: state.outreach.outreachDoelgroepen.Items,
    settings: state.outreach.outreachSettings.Item,
    medewerkers: state.selectie.allMedewerkersNoAll,
    addNewState: state.outreach.outreachItem.AddItem
});

// Outgoing functions to Dispatch
interface IDispatchProps {
    naviagations: INaviagtions;
    onLoadDoelgroepen: () => void;
    onLoadSettings: () => void;
    onLoadMedewerkers: () => void;
    onSave: (details: IOutreachItem) => void;
 }
const mapDispatchProps = (dispatch: Dispatch): IDispatchProps => ({
    naviagations: mapNavigationsToProps(dispatch),
    onLoadDoelgroepen: () => dispatch(RootActionCreators.Outreach.outreachDoelgroepen.FetchData()),
    onLoadSettings: () => dispatch(RootActionCreators.Outreach.outreachSettings.FetchData()),
    onLoadMedewerkers: () => dispatch(RootActionCreators.Selectie.FetchAllMedewerkers()),
    onSave: (details: IOutreachItem) => dispatch(RootActionCreators.Outreach.outreachItem.AddData(details))
});

// Actual Component
export type AllProps = IProps & IDispatch & IStateProps & IDispatchProps;
export const OutreachNew = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tOutreach } = useTranslation('outreach');
    const { t: tCommon } = useTranslation('common');

    // Create a new outreach item which is invalid by default
    const [details, setDetails] = React.useState<IOutreachItem>(EmptyOutreachItem);
    const [isValid, setIsValid] = React.useState(false);

    // Fetch missing data
    React.useEffect(() => {
        props.doelgroepen.state !== FetchState.Success && props.onLoadDoelgroepen();
    }, []);
    React.useEffect(() => {
        props.settings.state !== FetchState.Success && props.onLoadSettings();
    }, []);
    React.useEffect(() => {
        props.medewerkers.fetchState !== FetchState.Success && props.onLoadMedewerkers();
    }, []);


    // Check if all data is loaded
    const isLoading =
        props.doelgroepen.state !== FetchState.Success ||
        props.settings.state !== FetchState.Success ||
        props.medewerkers.fetchState !== FetchState.Success;


    // Check if there is an error
    const isError =
        props.doelgroepen.state === FetchState.Error ||
        props.settings.state === FetchState.Error ||
        props.medewerkers.fetchState === FetchState.Error;
    const errorMessages = [
        props.doelgroepen.errorMessage,
        props.settings.errorMessage,
        props.medewerkers.errorMessage
    ].join(', ');
    
    return (<OutreachNavigation navigations={props.naviagations} selected={OutreachNavigationPage.Registreren}>
            <PageHeader title={tOutreach('newOutreachPageTitle')} subTitle={tOutreach('newOutreachPageSubtitle')} explainText={tOutreach('newOutreachPageExplanation')} />
            <OutreachForm
                data={details}
                onUpdate={(data, isValid) => {setDetails(data); setIsValid(isValid); }}
                loading={isLoading}
                maxContacts={props.settings.data.maxContacts}
                maxDate={props.settings.data.maxDate}
                minDate={props.settings.data.minDate}
                minContacts={props.settings.data.minContacts}
                doelgroepen={props.doelgroepen.data}                

            />

            <SaveButton disabled={(isValid === false) || isLoading} onClick={() => props.onSave(details)} />

            {isError && <ErrorMessage message={tCommon('errorLoadingData')} title={tCommon('errorLoadingDataTitle')} errorDetails={errorMessages} options={[{optionLabel: tCommon('restart'), optionExecute: () => window.location.reload()}]} />}

        {props.addNewState.state === FetchState.Busy && ! isError && <SavingMessage entity={tOutreach('outreach')} />}
        {props.addNewState.state === FetchState.Error && ! isError && <ErrorMessage title={tCommon('savingErrorTitle')} message={tCommon('savingErrorXMessage', {x: props.addNewState.errorMessage})} canClose options={[]} errorDetails={JSON.stringify(details)} />}

        </OutreachNavigation>);
};

export default connect<IStateProps, IDispatchProps, {}, IApplicationState>(mapStateProps, mapDispatchProps)(OutreachNew);